import React from "react";
import { Logo } from "assets/svg";
import { useNavigate } from "react-router-dom";

const SentEmailResetPassword: React.FC = () => {
  const navigate = useNavigate();

  return (
    <main className="bg--blur box">
      <div
        className="w-full rounded-[20px] border-[8px] border-white bg-primary-light shadow-[0_0_15px_0_rgba(0,0,0,0.05)] flex flex-col items-center justify-center py-[52px] px-[22px]
        sm:max-w-[580px] sm:py-[72px] sm:px-[62px]"
      >
        <Logo className="w-[200px] h-[81px] mb-[16px] sm:w-[300px] sm:h-[121px] sm:mb-[24px]" />
        <h2 className="text-[20px] font-bold text-primary mb-[18px] text-center sm:text-[24px] sm:mb-[22px]">
          メールを送信しました
        </h2>
        <div className="text-[14px] font-normal leading-[160%] text-center mb-[22px] sm:text-[15px] sm:mb-[26px]">
          ご登録のメールアドレス宛に、 <br />
          パスワード再設定用のリンクを <br className="sm:hidden" />
          お送りしました。
        </div>
        <div className="text-[14px] font-normal leading-[160%] text-center mb-[22px] sm:text-[15px] sm:mb-[26px]">
          メール内のリンクをクリックして、 <br />
          パスワードの再設定を行ってください。
        </div>
        <span className="block text-[11px] text-gray-500 text-center mb-[20px] sm:text-[12px]">
          ※数分たっても届かない場合は、 <br className="sm:hidden" />
          迷惑メールフォルダをご確認ください。
        </span>
        <button
          type="button"
          className="w-full bg-primary text-white py-3 rounded-[6px] text-[16px] font-bold sm:max-w-[340px] sm:text-[17px] transition hover:bg-[#103E75]"
          onClick={() => navigate("/")}
        >
          ログイン画面に戻る
        </button>
      </div>
    </main>
  );
};

export default SentEmailResetPassword;
